import { styles } from '../constants/styles.js';

/**
 * Converts single CssProperty to a CssProperties, or passes through value if
 * it's already of type CssProperties
 */
var getCssProperties = function getCssProperties(properties) {
  return Array.isArray(properties) ? properties : [properties];
};
var breakpointsArray = ['default', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
var isCssValue = function isCssValue(boxPropValue) {
  return typeof boxPropValue === 'string' || typeof boxPropValue === 'number';
};

/**
 * Runs given function `f` on all cssValues in the boxPropValue
 */
var mapBoxPropValues = function mapBoxPropValues(boxPropValue, f) {
  return isCssValue(boxPropValue) ? [f(boxPropValue)] : breakpointsArray.filter(function (breakpoint) {
    return boxPropValue[breakpoint] !== undefined;
  })
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(function (breakpoint) {
    return f(boxPropValue[breakpoint], breakpoint);
  });
};

/**
 * Generates single row of CSS for given breakpoint, property and cssValue
 */
var generateBoxPropStyleRow = function generateBoxPropStyleRow(property) {
  return function (cssValue, breakpoint) {
    switch (breakpoint) {
      /**
       * `value` is either a CssValue or the 'default' breakpoint of a
       * ResponsiveProp, generate a basic `property: value` CSS row.
       */
      case undefined:
      case 'default':
        return "".concat(property, ": ").concat(cssValue, ";");

      /**
       * `value` is a ResponsiveProp, generate CSS inside suitable media query
       */
      default:
        return "".concat(styles.breakpoint[breakpoint], " { ").concat(property, ": ").concat(cssValue, "; }");
    }
  };
};

/**
 * Generates CSS out of a MaybeResponsiveProp Box prop value
 */
var generateBoxPropStyles = function generateBoxPropStyles(property, value) {
  return mapBoxPropValues(value, generateBoxPropStyleRow(property)).join('\n');
};

export { generateBoxPropStyleRow, generateBoxPropStyles, getCssProperties, mapBoxPropValues };
